import * as React from 'react';
import { ItemCart, QteMinMarquage } from './iCart';
import { removeItemCart, updateItemCart } from './CartAction';
import RenderPicto from './RenderPicto';
import { getShopInfosInStorage } from './ShopInfos';
import  RenderGuideTaille from './RenderGuideTaille';
import { Input } from '../inputs/Input';
import Modal from 'react-responsive-modal';
import { getShopRefInStorage } from '../mon-compte/MonCompteAction';
import Icons from '../mon-compte/Icons';
import {getFeatureEnabledPostprocessing, getHostApi} from '../../utils';
import { BlackListError, StockErrors } from './cartInterfaces';
import CartItemStockError from './CartItemStockError';
import {RenderContour} from "./RenderContour";
import CartProductViewer from './CartProductViewer';
import { TranslationProps, WithTranslation } from '../../contexts/TranslationContext';

interface ItemCartProps extends TranslationProps {
  cartItems: ItemCart[];
  cartId: string;
  problemeSericoat: any;
  stockErrors: StockErrors;
  blacklistError: BlackListError;
  isModeHT: boolean;
}

interface ItemCartState {
  modalIsOpen: boolean;
  modalStandardIsOpen: boolean;
  item3dSelected?: ItemCart;
  mug3dUrl?: string;
  modalUrl?: string;
  isLoaded: boolean;
  availability?: boolean;
  enabledPostProcessing: boolean;
  loadingInput: string | null;
}

class RenderItemsCart extends React.Component<ItemCartProps, ItemCartState> {
  constructor(props: ItemCartProps) {
    super(props);
    this.state = {
      modalIsOpen: false,
      modalStandardIsOpen: false,
      isLoaded: false,
      item3dSelected: undefined,
      enabledPostProcessing: false,
      loadingInput: null,
    };
  }

  componentDidMount(): void {
    getFeatureEnabledPostprocessing()
      .then(response => this.setState({ enabledPostProcessing: response.data?.feature ?? false}));
  }

  /**
   * Fonction retournant la source de l'image produit à afficher dans le panier
   * @param {ItemCart} item
   * @returns {any}
   */
  getSrcImgItem = (item: any) => {
    if(getShopRefInStorage() != 'DG' && typeof item.article?.links?.images === 'undefined') {
      item.article.links = item.links;
    }
    let linkImg = '';
    if (item.article?.links?.images['128x128']) {
      linkImg = item.article.links.images['128x128'][0] ? item.article.links.images['128x128'][0] :  item.article.links.images['128x128'][1]['lien'];
    } else if (item.article?.links?.images_principales['128x128']) {
      linkImg = typeof item.article.links.images_principales['128x128']['lien'] !== "undefined" ? item.article.links.images_principales['128x128']['lien'] : item.article.links.images_principales['128x128'];
    }
    return linkImg;
  }

  getSrcImgMiniature = (item: any) => {
    const boutiqueId = getShopInfosInStorage() ? getShopInfosInStorage().idBoutique : 11;
    return `${getHostApi()}/images/upload/${`${boutiqueId}-${item.creation_id}`}/miniatures/web/${item.creation_id}.png`;
  }

  getSrcAplatMug = (item: ItemCart) => {
    const CacheRandom = Math.random().toString(36).substring(7);
    return '/images/aplats/web/' + item.creation_id + '.jpg?time=' + CacheRandom;
  }

  /**
   * Fonction retournant le href vers la fiche produit d'un article
   * @param {ItemCart} item
   * @returns {string}
   */
  getItemLinkHref = (item: any) => {
    const shopInfos = getShopInfosInStorage();
    let link = '';

    if (item.article) {
      if (['MT', 'TE', 'TO', 'DT', 'TH'].includes(shopInfos.Ref) && item.article.links && item.article.links.product && item.article.links.product.fr) {
        link = item.article.links.product.fr;
        if (window.location.hostname.includes('deixo.com')) {
          link = link.replace('lamaisonduteeshirt.com', 'deixo.com');
        }
      }
    }
    return link;
  }

  onChangeQteItem(item: any, qte: string) {
    if(qte === '') {
      return;
    }
    this.setState({ loadingInput: item.id });
    const shopInfos = getShopInfosInStorage();
    const newQte = Number(qte);

    if (item && newQte && newQte > 0) {
      if (shopInfos && shopInfos?.Ref !== 'DG' && shopInfos?.Ref !== 'DT') {
        if (this.checkQteStock(item, newQte) && this.checkQteMarquage(item, newQte)) {
          updateItemCart({ quantite: newQte }, item.id).then(() => this.setState({ loadingInput: null }));
        } else {
          updateItemCart({ quantite: item.quantite }, item.id).then(() => this.setState({ loadingInput: null }));
        }
      } else {
        if(shopInfos.Ref === 'DT' && !this.checkQteMarquageDT(item, newQte)) {
          updateItemCart({ quantite: item.quantite }, item.id).then(() => this.setState({ loadingInput: null }));
          alert('La quantité minimum est de ' + shopInfos.quantiteMin + ' transferts.');
          return false;
        } else {
          updateItemCart({quantite: newQte}, item.id).then(() => this.setState({ loadingInput: null }));
        }
      }
    }

    if(item && newQte <= 0) {
      this.onChangeQteItemDelete(item, qte);
    }
  }

  onChangeQteItemDelete(item: any, qte: string) {
    this.setState({ loadingInput: item.id });
    const newQte = Number(qte);
    if (newQte <= 0) {
      const result = this.removeItemCart(item.id);
      if (result === false) {
        updateItemCart({ quantite: item.quantite }, item.id).then(() => this.setState({ loadingInput: null }));
      }
    }
  }

  /**
   * Fonction permettant de vérifier la quantité du stock d'un article
   * @param {ItemCart} item
   * @param {number} newQte
   * @returns {boolean}
   */
  checkQteStock(item: any, newQte: number) {
    let result = true;
    const stockGlobal = Number(item.article.Stock) + Number(item.article.stock_frs_corrige);
    let multiple =  Number(item.multiple) ? Number(item.multiple) : 1 ;
    const multipleFrsMax =  Number(item.multiple_frs_max) ? Number(item.multiple_frs_max) : 0 ;
    const stockFrsMax =  Number(item.stockFrs);

    if(newQte > stockFrsMax) {
      multiple = multipleFrsMax;
    }

    if (stockGlobal < newQte) {
      result = false;
      let commentaire = ' en taille ' + item.article.taille.Taille
      if(item.article.taille.Taille.includes('taille_unique')) {
        commentaire = '';
      }
      alert('Seulement ' + stockGlobal + ' articles' + commentaire +' sont disponibles. ' +
        'Vous ne pouvez pas commander une quantité supérieure au stock.');
    } else if (newQte % multiple !== 0) {
      result = false;
      alert('cet article ne peut être commandé que par multiple de ' + multiple);
    }

    return result;
  }

  /**
   * Fonction permettant de vérifier la quantité saisie avant de mettre à jour la ligne du panier
   * @param {ItemCart} itemUpdated
   * @param {number} newQte
   * @returns {boolean}
   */
  checkQteMarquage(itemUpdated: any, newQte: number) {
    let result = true;
    const qteTotalItemsRefCouleur = this.getQteByItemsRefCouleur(itemUpdated);
    const newQteTotal = qteTotalItemsRefCouleur + (newQte - Number(itemUpdated.quantite));
    const qteMinMarquage = this.getQteMinMarquage();

    if (itemUpdated.marquage.libelle === 'Sérigraphie' && newQteTotal < qteMinMarquage.tarif_qte_min_serigraphie) {
      result = false;
      alert('La technique de marquage SeriCoat nécessite une quantité minimum de ' +
        qteMinMarquage.tarif_qte_min_serigraphie + ' pièces');
    } else if (itemUpdated.marquage.libelle === 'Broderie' && newQteTotal < qteMinMarquage.tarif_qte_min_broderie) {
      result = false;
      alert('La broderie nécessite une quantité minimum de ' + qteMinMarquage.tarif_qte_min_broderie + ' pièces');
    } else if (itemUpdated.marquage.libelle === 'Sublimation'
        && newQteTotal < qteMinMarquage.tarif_qte_min_sublimation) {
      result = false;
      alert('La sublimation nécessite une quantité minimum de ' + qteMinMarquage.tarif_qte_min_sublimation);
    }

    return result;
  }

  checkQteMarquageDT(itemUpdated: any, newQte: number) {
    let result = true;
    const shopInfos = getShopInfosInStorage();
    const isMarquage = itemUpdated.data?.marquage_id;
    if(isMarquage && isMarquage == 3) {
      if(newQte < shopInfos.quantiteMin) {
        result = false;
      }
    }
    return result;
  }

  /**
   * Fonction permettant de récupérer les variables de qte min marquage dans le sessionStorage
   * @returns {QteMinMarquage}
   */
  getQteMinMarquage() {
    const qteMinMarquage: QteMinMarquage = {
      tarif_qte_min_broderie: 0,
      tarif_qte_min_serigraphie: 0,
      tarif_qte_min_sublimation: 0,
    };
    const shopInfos = getShopInfosInStorage();

    if (shopInfos.qte_min_marquage) {
      qteMinMarquage.tarif_qte_min_broderie = shopInfos.qte_min_marquage.tarif_qte_min_broderie;
      qteMinMarquage.tarif_qte_min_serigraphie = shopInfos.qte_min_marquage.tarif_qte_min_serigraphie;
      qteMinMarquage.tarif_qte_min_sublimation = shopInfos.qte_min_marquage.tarif_qte_min_sublimation;
    }

    return qteMinMarquage;
  }

  /**
   * Fonction permettant de récupérer la quantité total par produit, couleur, surface
   * @param {ItemCart} itemUpdated
   * @returns {number}
   */
  getQteByItemsRefCouleur(itemUpdated: any) {
    let qteTotal = 0;
    const key = this.generateKeyItem(itemUpdated);

    this.props.cartItems.forEach((item) => {
      const tmpKey = this.generateKeyItem(item);
      if (tmpKey === key) {
        qteTotal += Number(item.quantite);
      }
    });

    return qteTotal;
  }

  /**
   * Fonction permettant de générer un clé item à partir de la référence, couleur, finition et la surface
   * @param {ItemCart} item
   * @returns {string}
   */
  generateKeyItem(item: any) {
    const shopInfos = getShopInfosInStorage();
    let key = item.article.produit.Reference + '_' + item.article.couleur.idCouleursArticles + '_' +
      item.marquage.finition;

    if (shopInfos.Ref !== 'MT') {
      key = item.article.produit.Reference + '_' + item.article.couleur.idCouleursArticles + '_' +
        item.surfaces[0]?.surface.surface.nom + '_' + item.marquage?.finition + '_' + item.surfaces[0]?.surface.emplacement.nom;
    }

    return key;
  }

  /**
   * Fonction permettant de supprimer un article du panier
   * @param {string} itemId
   */
  removeItemCart(itemId: string) {
    if (confirm(this.props.textsContent?.['CART_LINE_DELETE_CONFIRM'])) {
      removeItemCart(itemId);
    } else {
      return false;
    }
  }

  /**
   * Fonction permettant de récupérer le taux de dégréssivité
   * @param {number} puSansDegressiviteHT
   * @param {number} puHT
   * @returns {number}
   */
  getPercentDegressivite(puSansDegressiviteHT: number, puHT: number) {
    return Math.round(100 - ((puHT / puSansDegressiviteHT) * 100) + 0.1);
  }

  open3dObject(item: ItemCart) {
    this.setState({ item3dSelected: item });
  }

  openModal = (url: string) => {
    this.setState({ modalStandardIsOpen: true, modalUrl: url });

  }

  isLoaded = () => {
    this.setState({ isLoaded: true });
  }

  render() {

    const renderTitleMug = (item: any) => {
      let title = item.marquage.nom;

      if (item.marquage.nom == 'theme') {
        title = 'à ' + title;
      }

      return 'Mug ' + title;
    };

    const renderSurfaces = (item: any) => {
      const html: string[] = [];

      if (item.surfaces.length > 0) {
        item.surfaces.forEach((element: any, i: any) => {
          if (element.surface && element.surface_id > 0) {
            html.push(element.surface.surface.nom.charAt(0).toUpperCase() + element.surface.surface.nom.substr(1) + ' ' +
                element.surface.emplacement.nom);
          }
        });
      }

      return html.join(', ');
    };

    const renderInfosArticle = (item: any, index : number) => {
      let nbrCouleurs = 'couleurs';
      if(item.nb_couleurs_marquage && parseInt(item.nb_couleurs_marquage) ===1) {
        nbrCouleurs='couleur';
      }
      return (
        <div className="col-sm-9 col-xl-3 col-lg-3 col-md-5 col-9 cartDescProductCol">
          <div className="cartItemTitle">
            {getShopRefInStorage()  == 'ME' ? (
              <div className="d-flex align-items-center">
                <div className="flex-grow-1 text-uppercase small black ">{renderTitleMug(item)} </div>
                <a onClick={() => this.open3dObject(item)} className="position-relative">
                  <img src={this.getSrcAplatMug(item)} className="itemImgAplat ml-1 border"/>
                </a>
              </div>
            ) : (
              <a href={this.getItemLinkHref(item)} className="position-relative">
                <span className="itemTitle black pr05">{item.article.produit.Titre}</span>
                {getShopRefInStorage() != 'DT' &&
                <span
                  className="itemReference grey small text-lowercase">{item.article.produit.reference_visible}</span>
                }
              </a>
            )}
          </div>
          {(getShopRefInStorage() != 'ME') &&
            <>
              {(item.article.produit.marque.nom !== 'DuckTransfer' && item.article.produit.marque.nom !== 'Duckgifts') &&
              <div>
                <span className="colorOpac">{this.props.textsContent?.['CART_LINE_DESCRIPTION_BRAND']} </span>
                <span>{item.article.produit.marque.nom} </span>
              </div>
              }
              {(getShopRefInStorage() != 'DT' || (getShopRefInStorage() == 'DT' && typeof item.surfaces[0] === 'undefined'))  &&
              <div>
                {getShopRefInStorage() != 'DT' &&
                <span className="colorOpac">{this.props.textsContent?.['CART_LINE_DESCRIPTION_COLOR']} </span>
                }
                <span>{item.article.couleur.Couleur}</span>
              </div>
              }
              <div>
                {getShopRefInStorage() == 'DT' && item.surfaces[0] ? (
                  <>
                    <span className="colorOpac">{this.props.textsContent?.['CART_LINE_DESCRIPTION_DIMENSION']} </span>
                    <span>{item.surfaces[0].largeur}cm x {item.surfaces[0].hauteur}cm</span>
                  </>
                ) : (
                  <>
                    <span className="colorOpac">{this.props.textsContent?.['CART_LINE_DESCRIPTION_SIZE']} </span>
                    <span>{item.article.taille.Taille} </span>
                  </>
                )}

                {getShopRefInStorage() == 'DT' && item.surfaces[0] && item.contourCmjn && <RenderContour data={item.contourCmjn[item.surfaces[0].surface_id]}/>}

                <RenderGuideTaille item={item} />

                {(getShopRefInStorage() != 'MT' && getShopRefInStorage() != 'DT' && item.marquage.id) ?
                  <div className="d-block">
                    <p className="m-0 p-0"><span className="colorOpac">{this.props.textsContent?.['CART_LINE_DESCRIPTION_SURFACE']} </span>{renderSurfaces(item)}</p>
                    <p className="m-0 p-0">
                      <span className="colorOpac">{this.props.textsContent?.['CART_LINE_DESCRIPTION_MARKING']} </span>{item.marquage.libelle}
                      { (getShopRefInStorage() === 'DG' && parseInt(item.nb_couleurs_marquage) >= 1) &&
                        <>
                      &nbsp; {item.nb_couleurs_marquage} {nbrCouleurs} &nbsp;({item.couleurs_marquage})
                      </>
                      }
                    </p>
                  </div> : ''
                }
              </div>
            </>
          }
        </div>
      );
    };

    const renderPU = (item: any) => {
      const degressivite = this.getPercentDegressivite(item.pu_sans_degressivite_ht, item.pu_ht);
      let classBootstrap = 'col-lg-2 col-xl-2';
      if (getShopRefInStorage()  == 'MT' || getShopRefInStorage()  == 'ME') {
        classBootstrap = 'col-lg-3 col-xl-3';
      }

      return (
        <div className={classBootstrap + ' d-flex justify-content-center flex-wrap colPuhtCart col-sm-8 col-md-2 col-9'}>
          {degressivite > 0 &&
            <div className={`font14 ${getShopRefInStorage()  == 'DT' ? 'col-3 col-lg-6' : 'col-3 col-md-12 col-lg-4'} text-right p-0`}>
              <span className="itemPuSansDegressivite">
                {item?.[`pu_sans_degressivite_${this.props.isModeHT ? 'ht' : 'ttc'}`].toFixed(2).replace('.', ',')} €
              </span>
            </div>
          }

          {(degressivite > 0 || (item.marquage.nom  == 'carton' && getShopRefInStorage()  == 'MT')) &&
            <div className="font14 col-3 col-md-12 col-lg-4 text-center text-md-right text-lg-center p-0">
              {degressivite > 0 &&
              <span className="remisePu remiseCart rounded mx-1 font-weight-bold" title="Remise de dégressivité">
                  -{this.getPercentDegressivite(item.pu_sans_degressivite_ht, item.pu_ht)}%
                </span>
              }
              {(item.marquage.nom  == 'carton' && getShopRefInStorage()  == 'MT')  &&
              <div title="Remise prix au carton" className="text-center">
                <img src="/order/images/ic-carton.svg" alt="Carton" width="14px" />
              </div>
              }
            </div>
          }
          <div className={getShopRefInStorage()  == 'DT' ? 'font14 col-3 col-lg-6 p-0 d-flex flex-column align-items-end colPuhtCartDiv ' : 'font14 col-4 col-md-12 col-lg-4 p-0 d-flex flex-column align-items-end colPuhtCartDiv'}>
            <span>{item?.[`${this.props.isModeHT ? 'pu_ht' : 'pu_ttc'}`].toFixed(2).replace('.', ',')} €
              <span style={{ fontSize: '9px', verticalAlign: 'top' }}> {!this.props.isModeHT ? this.props.textsContent?.['SWITCH_TEXT_TTC'] : this.props.textsContent?.['SWITCH_TEXT_HT']}</span>
            </span>
            <div style={{ fontSize: '12px', color: '#8c8c8c' }}>
              {item?.[`${this.props.isModeHT ? 'pu_ttc' : 'pu_ht'}`].toFixed(2).replace('.', ',')} €
              <span style={{ fontSize: '9px', verticalAlign: 'top' }}> {!this.props.isModeHT ? this.props.textsContent?.['SWITCH_TEXT_HT'] : this.props.textsContent?.['SWITCH_TEXT_TTC']}</span>
            </div>
          </div>
        </div>
      );
    };

    /**
     * Arronfi le prix total HT de l'article à 2 décimales
     * @returns {string}
     * @param pt_ht
     */
    const getTotalItemHT = (pt_ht: number) => {
      return (
        pt_ht.toFixed(2).replace('.', ',') + ' €'
      );
    };

    const renderBtnDelete = (item: any) => {
      return (
          <button onClick={() => this.removeItemCart(item.id)} title={this.props.textsContent?.['CART_LINE_BTN_DELETE_TITLE']}
                  className="btnRemoveItem text-right border-0 ml1">
              <Icons icon="delete" className="align-middle" size={17} fill="black" />
          </button>
      );
    };

    const renderTaxes = (item: any) => {
      const html = [];

      if (item.article.taxe_sorecop != null && item.article.taxe_sorecop != 0.00) {
        html.push(<div className={"text-secondary font12 font-italic"}>Dont {(item.article.taxe_sorecop*item.quantite).toFixed(2).replace('.', ',')}€ de taxe Sorecop</div>);
      }
      if (item.article.taxe_sorecop != null && item.article.taxe_deee != 0.00) {
        html.push(<div className={"text-secondary font12 font-italic"}>Dont {(item.article.taxe_deee*item.quantite).toFixed(2).replace('.', ',')}€ de taxe DEEE</div>);
      }

      return html;
    }

    const renderTotalHt = (item: any) => {
      return (
        <div className="col-lg-2 col-xl-2 col-sm-12 col-md-2 col-12 d-flex flex-column contentItemPrice">
          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap">
            <div className="font14 d-flex flex-column align-items-end">
              <div>
                {getTotalItemHT(item?.[`${this.props.isModeHT ? 'pt_ht' : 'pt_ttc'}`])}
                <span style={{ fontSize: '9px', verticalAlign: 'top' }}> {!this.props.isModeHT ? this.props.textsContent?.['SWITCH_TEXT_TTC'] : this.props.textsContent?.['SWITCH_TEXT_HT']}</span>
              </div>
              <div style={{ fontSize: '12px', color: '#8c8c8c' }}>
                {getTotalItemHT(item?.[`${this.props.isModeHT ? 'pt_ttc' : 'pt_ht'}`])}
                <span style={{ fontSize: '9px', verticalAlign: 'top' }}> {!this.props.isModeHT ? this.props.textsContent?.['SWITCH_TEXT_HT'] : this.props.textsContent?.['SWITCH_TEXT_TTC']}</span>
              </div>
            </div>
            {renderBtnDelete(item)}
          </div>
          <div className="text-right">
            {renderTaxes(item)}
          </div>
        </div>
      );
    };

    /**
     * Ne s'affiche que pour TO et TE
     * @param {ItemCart} item
     * @returns {any}
     */
    const renderPictos = (item: any) => {
      const shopInfos = getShopInfosInStorage();
      /** Pour les tests : */
      // shopInfos.Ref = "MT";
      if (shopInfos && ['TE', 'TO', 'TH'].includes(shopInfos.Ref)) {
        return (
          <RenderPicto item={item} />
        );
      }
    };

    const renderImgArticle = (item: any, index: number) => {
      const shopRef = getShopRefInStorage();
      return (
        <div className="col-xl-1 col-lg-1 col-md-1 col-sm-3 col-3 text-center p-0">
          {shopRef === 'DT' && item.marquage?.id != 0 && (
            <a onClick={() => this.openModal(this.getSrcImgMiniature(item))} className="itemLinkImg bg-alphaImg cursor-pointer">
              <img src={this.getSrcImgMiniature(item)} className="itemImg mb-1 w-100 p-0 h-auto"/>
            </a>
          ) || (shopRef === 'ME' || parseInt(item?.is_model_3d ?? '0') === 1) && (
            <a onClick={() => this.open3dObject(item)} className="itemLinkImg w-100 h-100">
              <div className="itemImg mb-1 w-100 p-0 cursor-pointer position-relative" style={{height: '100px'}}>
                <CartProductViewer item={item} canMove={false} shopRef={shopRef} />
                <img
                  className="position-absolute"
                  style={{ bottom: '4px', right: '4px' }}
                  src="/order/images/ic-zoom.svg"
                  width="25"
                  height="25"
                />
              </div>
            </a>
          ) || (
            <a href={this.getItemLinkHref(item)}>
              <img src={this.getSrcImgItem(item)} className="itemImg mb-1 w-100 p-0 h-auto"/>
            </a>
          )}
        </div>
      );
    };

    const renderQtyArticle = (item: ItemCart, problemSericoat : boolean) => {
      let classProblemeSericoat = '';
      const classError = this.props?.stockErrors?.errorItems?.[item.id]?.error
          ? 'borderError' : '';
      if(problemSericoat) {
        classProblemeSericoat = ' alert-danger ';
      }
      return (
        <div className={getShopRefInStorage()  == 'DT' ? 'col-sm-3 col-xl-4 col-lg-4 col-md-4 col-3 text-center colQtyCart' : 'col-sm-3 col-xl-1 col-lg-1 col-md-1 col-3 colQtyCart'}>
          <Input disabled={item.id == this.state.loadingInput} type="number" value={item.quantite} onBlur={value => this.onChangeQteItemDelete(item, value)} delay={500}  onChange={value => this.onChangeQteItem(item, value)}
                 className={`itemQte text-center mw-100 rounded py-1 ${classProblemeSericoat} ${classError}`} min={0}/>
        </div>
      );
    };

    const renderDisponibilite = (item: any) => {
      const {textsContent, stockErrors, blacklistError} = this.props;

      let baseline = '';
      if (item.availability) {
        baseline = textsContent?.['CART_LINE_AVAILABILITY_INSTANT_SEND'] ?? '';
      }

      let classBootstrap = 'col-lg-1 col-xl-1';
      if (getShopRefInStorage()  == 'MT' || getShopRefInStorage()  == 'ME') {
        classBootstrap = 'col-lg-2 col-xl-2';
      }
      const stock = stockErrors?.errorItems?.[item.id];
      const itemBlackList = blacklistError.errorItems.find(errorItem => errorItem.id === item.id);

      if (!blacklistError.valid && itemBlackList) {
        return (
          <div className={`${classBootstrap} text-center text-uppercase font-weight-bold font12 text-danger w-100 m-3 m-lg-0`}>
            {this.props.textsContent?.['CART_LINE_AVAILABILITY_BLACKLIST_ERROR']}
          </div>
        );
      } else if (stockErrors && !stockErrors.valid && stock?.error) {
        return (
          <CartItemStockError
            className={classBootstrap}
            stock={Number(stock?.quantite)}
          />
        );
      }

      return (
        <div className={classBootstrap + ' col-md-1 col-12 d-flex align-items-center text-uppercase justify-content-center font-weight-bold font14 flex-wrap' +
        ' text-lg-center text-left w-100 available font12'} style={{ lineHeight: '1.1em', whiteSpace: 'pre-line' }}>
          {this.props.textsContent?.['CART_LINE_AVAILABILITY_IN_STOCK']}
          <div className={'small text-lowercase pl-1 m-0 lineheight1'}>{baseline}</div>
        </div>
      );
    };

    /**
     * Affiche une ligne de panier pour chaque article contenus dans le panier
     * @type {any[]}
     */
    const renderlistItems = [].concat(this.props.cartItems as [])
      .sort((a: any, b: any) => {
        const aId = a.article.produit.idProduits + a.article.couleur.idCouleursArticles;
        const bId = b.article.produit.idProduits + b.article.couleur.idCouleursArticles;
        let resultSort = a.article.taille.ordre - b.article.taille.ordre;
        // Si les produits sont différents ou que la couleurs est différente alors on tri différemment
        if (aId !== bId) {
          resultSort = aId - bId;
        }
        return resultSort;
      })
      .map((item: ItemCart, index: number) => {
        let problemSericoat = false;
        if (this.props.problemeSericoat && this.props.problemeSericoat.length > 0) {
          this.props.problemeSericoat.forEach((element : any, i : any) => {
            element['item'].forEach((elementItem : any, j : any) => {
              if (elementItem === item.id) {
                problemSericoat = true;
              }
            });
          });
        }
        const classProblemeSericoat = problemSericoat ? ' ' : '';
        return (
        <div
          key={item.id}
          id={`cartArticleId-${item.id}`}
          className={`cartItem d-flex flex-wrap align-items-center p-2 border-bottom ${classProblemeSericoat}`}
        >
          {renderImgArticle(item, index)}
          {renderInfosArticle(item, index)}
          {renderPictos(item)}
          {(getShopRefInStorage() != 'DT') &&
          <>{renderDisponibilite(item)}</>
          }
          {renderPU(item)}
          {renderQtyArticle(item, problemSericoat)}
          {renderTotalHt(item)}
        </div>
        );
      });

    return (
      <div id="containerCartItem" className="font11 border">
        {renderlistItems}
        <Modal
          open={this.state.item3dSelected !== undefined}
          classNames={{ overlay: 'bootstrap-container', modal: 'modal-3d' }}
          center
          onClose={() => this.setState({ item3dSelected: undefined })}
        >
          {this.state.item3dSelected && (
            <CartProductViewer item={this.state.item3dSelected} shopRef={getShopRefInStorage()} canMove enabledPostProcessing={this.state.enabledPostProcessing} />
          )}
        </Modal>
        <Modal classNames={{ overlay: 'bootstrap-container' }} open={this.state.modalIsOpen} center
               onClose={ () => this.setState({ modalIsOpen: false , isLoaded:false }) }>

            {!this.state.isLoaded &&
              <div className="imgLoadContainer" style={{ width: '460px', height: '460px' }}>
                <img className="imgLoad" src="/order/images/loading.gif" alt="" />
              </div>
            }
          <div style={{ width: '460px', height: '460px' }}>
            <iframe frameBorder="0" onLoad ={() => this.isLoaded()}
                    style={{ height: '100%', width: '100%' }}
                    src={this.state.mug3dUrl}
                    className="cboxIframe" allowFullScreen={true} />
          </div>
        </Modal>
        <Modal classNames={{ overlay: 'bootstrap-container' }} open={this.state.modalStandardIsOpen} center={true}
               onClose={ () => this.setState({ modalStandardIsOpen: false , isLoaded:false }) }>
            <img  className={'bg-alpha'}
                    style={{ height: '100%', width: '100%' }}
                    src={this.state.modalUrl}/>
        </Modal>
      </div>
    );
  }
}

export default WithTranslation<ItemCartProps>(RenderItemsCart, 'CART_TUNNEL', 'SWITCH_TAXES_PRICES');
